var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTransfer = function SvgTransfer(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 21 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "transfer")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.1-Home",
    transform: "translate(-34.000000, -462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transfer",
    transform: "translate(32.000000, 458.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(3.000000, 5.000000)",
    stroke: "#000000de",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.062400, 4.083335) rotate(90.000000) translate(-5.062400, -4.083335) translate(0.979065, -0.979065)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinejoin: "round",
    points: "-1.93622895e-13 6.2065 4.08337 10.1248 8.16667 6.2065"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.08337,
    y1: 9.0942,
    x2: 4,
    y2: 0,
    id: "Path"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(13.062400, 10.083335) scale(-1, 1) rotate(90.000000) translate(-13.062400, -10.083335) translate(8.979065, 5.020935)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinejoin: "round",
    points: "-1.93622895e-13 6.2065 4.08337 10.1248 8.16667 6.2065"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.08337,
    y1: 9.0942,
    x2: 4,
    y2: 0,
    id: "Path"
  }))))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransfer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transfer.4da0cb5a.svg";
export { ForwardRef as ReactComponent };